module.exports = __webpack_public_path__ + "img/02tab-slot.0418c602.png";